<template>
<div id="text-input-ai-autofill-v1-wd3kpg">
    <b-form-group id="text-input-ai-autofill-v1-sl6gbq" v-if="showType == 'form-builder'" :description="properties.description" :label="properties.label" :style="properties.style">
      <b-form-textarea id="text-input-ai-autofill-v1-a0i18j" :placeholder="properties.placeholder" :rows="1" :max-rows="4"></b-form-textarea>
    </b-form-group>
    <div id="text-input-ai-autofill-v1-aj7g93" v-if="showType == 'properties'">
      <text-input-ai-autofill-v1-properties id="text-input-ai-autofill-v1-1gfy29" :formId="formId" :options="dropdownOptions"></text-input-ai-autofill-v1-properties>
    </div>
    <b-form-group id="text-input-ai-autofill-v1-a9qmnz" style="font-size: 14px" v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      " :description="
        computedConditions.description
        ?
         computedPropertiesForm.description 
         : properties.description
      " :style="properties.style" v-show="!computedHidden" :state="state" :invalid-feedback="errors.join(', ')">
      <template v-slot:label>
        <div id="text-input-ai-autofill-v1-7hzty9" class="d-flex justify-content-between align-items-center">
          <div id="text-input-ai-autofill-v1-9okokc">
            {{ computedConditions.label
            ? computedPropertiesForm.label
            : properties.label }}
          </div>
          <div id="text-input-ai-autofill-v1-8r4y3v" v-if="config.serverSegment == 'core'">
            <b-dropdown id="text-input-ai-autofill-v1-k1djui" text variant="link" size="sm" no-caret ref="responsesDropdown" boundary="viewport" right @show="getSavedResponses">
              <template #button-content>
                <i id="text-input-ai-autofill-v1-581ldw" class="fas fa-ellipsis-v text-secondary"></i>
              </template>
              <b-dropdown-form id="text-input-ai-autofill-v1-zkf9i0">
                <div id="text-input-ai-autofill-v1-u8sbpz" v-if="currentFormId != 'previewForm'" class="dropdown-item hover-pointer" :disabled="!localValue" style="font-size: 14px;" @click="saveResponse"><i id="text-input-ai-autofill-v1-az5k36" class="fas fa-save mr-2"></i>Save value</div>              
                <div id="text-input-ai-autofill-v1-k24zl7" class="px-2" style="padding: 14px; font-size: 14px; background-color: #f4f7fb">
                  Load value:
                </div>
              </b-dropdown-form>
              <div class="dropdown-item hover-pointer" v-for="(s, i) in combinedResponses" :key="s.id" @click="writeResponse(s.response)" :id="'text-input-ai-autofill-v1-p7wcla-' + i">
                <div class="d-flex flex-row align-items-center justify-content-between" style="font-size: 14px;" :id="'text-input-ai-autofill-v1-wi51li-' + i">                  
                  <div class="mr-3" style="white-space: normal" :id="'text-input-ai-autofill-v1-adufvt-' + i"><i class="fas fa-clone mr-2" :id="'text-input-ai-autofill-v1-z1hjtj-' + i"></i>{{ s.response }}</div>
                  <i class="fas fa-trash text-danger" :style="{ visibility: s.isPredefined ? 'hidden' : 'visible' }" @click.stop="deleteResponse(s.id)" :id="'text-input-ai-autofill-v1-39xe3x-' + i"></i>
                </div>
              </div>
            </b-dropdown>
          </div>
        </div>
      </template>
      <b-form-textarea id="text-input-ai-autofill-v1-12svwf" style="font-size: 14px" :placeholder="
          computedConditions.placeholder
            ? computedPropertiesForm.placeholder
            : properties.placeholder
        " :readonly="
          computedConditions.readonly
            ? computedPropertiesForm.readonly
            : properties.readonly
        " :required="
          computedConditions.required
            ? computedPropertiesForm.required
            : properties.required
        " v-model="localValue" @blur="controlValue = localValue" :state="state" :rows="1" :max-rows="4"></b-form-textarea>
    </b-form-group>
    <b-form-group id="text-input-ai-autofill-v1-vm1h3e" v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      " :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      ">
      {{ controlValue }}
    </b-form-group>
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import TextInputAiAutofillV1Properties from "./TextInputAiAutofillV1Properties.vue";
import savedResponseServer from "../../../../server/userResponse";
import config from "../../../../server/serverCfg";
import { nablaCopilotKeySections } from '../../../../helpers/general';

export default {
  name: "TextInputAiAutofillV1",
  components: { TextInputAiAutofillV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: [
        "description",
        "label",
        "hidden",
        "placeholder",
        "readonly",
        "required",
        "responseOptions"
      ],
      dropdownOptions: [
        { value: null, text: 'Please select an option' },
        ...nablaCopilotKeySections.sort().map(section => {
          return { value: section, 
            text: section.toLowerCase()
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, l => l.toUpperCase()) 
          };
        })
    ],
      computedConditions: {},
      value: "",
      localValue: "",
      savedResponses: [],
      config: config,
      savedResponsesLoaded: false
    };
  },
  mounted() {
    this.computeConditions();
    this.localValue = this.controlValue;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group" style="${this.getComponentComputedProperties(
        "style"
      )}">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${this.controlValueFormatted || ""}
        </div>
      </fieldset>`;
    },
    async saveResponse(e) {
      if (this.currentFormId == "previewForm") return;
      e.stopPropagation()
      if(this.localValue.trim() && !this.combinedResponses.find(r => r.response.trim() == this.localValue.trim())) {
        await savedResponseServer.create({
          formId: this.currentFormId,
          componentId: this.id,
          response: this.localValue,
        });
        await this.getAllResponses();
        this.updatePopper();
      }
      
    },
    updatePopper() {
      this.$refs.responsesDropdown.updatePopper();
    },
    async deleteResponse(id){
      await savedResponseServer.delete(id);
      await this.getAllResponses();
      this.updatePopper();
    },
    async getAllResponses(){
      this.savedResponses = this.currentFormId == "previewForm" ? [] : await savedResponseServer.query(this.currentFormId, this.id);
    },
    writeResponse(response){
      this.controlValue = response;
    },
    async getSavedResponses() {
      if (!this.savedResponsesLoaded) {
        await this.getAllResponses();
        this.savedResponsesLoaded = true;
      }
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentFormId: state => state.form.id,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValueFormatted() {
      return this.controlValue?.replaceAll("\n", "<br/>");
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
    predefinedOptions() {
      const responseOptions = this.computedConditions.responseOptions
        ? this.computedPropertiesForm.responseOptions
        : this.properties.responseOptions;
      return responseOptions;  
    },
    combinedResponses(){
      const predefinedOptions = this.predefinedOptions ?? [];
      return predefinedOptions.map(p => ({
          response: p,
          isPredefined: true
        })).concat(this.savedResponses);
    }
  },
  watch: {
    controlValue(newValue) {
      if (newValue != this.localValue) {
        this.localValue = newValue;
      }
    }
  }
};
</script>

<style scoped>
.dropdown-menu {
  width: max-content;
  max-height: 300px;
  max-width: 500px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 0.25rem 0.5rem;
}
</style>
